import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ContactInfoModal({ isOpen, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: ""
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-2xl text-text-primary">
            Contact Information
          </DialogTitle>
          <DialogDescription className="font-body text-text-secondary">
            Please provide your contact information to connect with this provider.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="full_name" className="font-body font-semibold text-text-primary">
              Full Name *
            </Label>
            <Input
              id="full_name"
              name="full_name"
              data-testid="contact-full-name"
              value={formData.full_name}
              onChange={handleChange}
              required
              className="mt-2 h-12 font-body"
              placeholder="John Doe"
            />
          </div>
          <div>
            <Label htmlFor="email" className="font-body font-semibold text-text-primary">
              Email Address *
            </Label>
            <Input
              id="email"
              name="email"
              type="email"
              data-testid="contact-email"
              value={formData.email}
              onChange={handleChange}
              required
              className="mt-2 h-12 font-body"
              placeholder="john@example.com"
            />
          </div>
          <div>
            <Label htmlFor="phone" className="font-body font-semibold text-text-primary">
              Phone Number *
            </Label>
            <Input
              id="phone"
              name="phone"
              type="tel"
              data-testid="contact-phone"
              value={formData.phone}
              onChange={handleChange}
              required
              className="mt-2 h-12 font-body"
              placeholder="(555) 123-4567"
            />
          </div>
          <div className="flex gap-3 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              className="flex-1 h-12 font-body font-semibold"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              data-testid="submit-contact-info"
              className="flex-1 h-12 bg-primary text-white hover:bg-[#238C82] font-body font-semibold"
            >
              Continue
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
